<template>
  <div class="homeQuotationDetail HomeContainer">
    <div class="detailContainer" v-if="detail" key="detail">
      <div class="mainContainer">
        <div class="imgContainer">
          <el-image
            class="mainImg"
            :src="detail.img_array[imgIndex]"
            fit="contain"
            :preview-src-list="detail.img_array"
          ></el-image>
          <div class="imgList">
            <el-image
              :src="item"
              fit="cover"
              :preview-src-list="detail.img_array"
              :class="{ selected: imgIndex == index }"
              v-for="(item, index) of detail.img_array"
              :key="index"
              @mouseenter="imgIndex = index"
            ></el-image>
          </div>
        </div>

        <div class="basicContainer">
          <div class="title">
            <img :src="GetResourceUrl('flags/' + detail.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
            <span style="vertical-align: middle;margin-left:6px;">{{ detail.title }}</span>
            

            <!-- <i
              class="el-icon-view"
              style="
                padding-left: 5px;
                font-size: 14px;
                color: #999;
                margin-left: 20px;
                white-space: nowrap;
                vertical-align: middle;
              "
            >
              {{ detail.browse_count }}
            </i> -->
          </div>
          <div class="price">
            <template v-if="detail.specification_amount[0].price == l('电议')">
              {{ l("价格电议") }}
            </template>
            <template v-else>
              {{ detail.specification_amount[0].price }}{{l("元")}}/{{
                l(detail.specification_amount[0].unit)
              }}
            </template>
          </div>
          <div class="materialInfo">
            <div class="line">
              {{ l("品质") }}：
              {{
                $utils.listFilter(
                  $store.state.basicInfo.characterList,
                  detail.character
                )
              }}
            </div>
            <div class="line">
              {{ l("品名") }}：
              {{ l($store.getters.getCategory(detail.category_id)) }}
              {{ l(detail.child_category) }}
            </div>

            <div class="line">{{ l("材料") }}：{{ detail.material }}</div>
            <div class="line">
              {{ l("规格") }}：{{
                detail.specification_amount[0].specification
              }}
            </div>
            <div class="line">{{ l("钢厂") }}：{{ detail.steel_mill }}</div>
          </div>
          <el-button
            type="warning"
            style="width: 150px; height: 40px; margin-top: 25px"
            @click="doBusiness"
            >{{
              detail.business_action_code ? l("修改我的询价") : l("我要询价")
            }}</el-button
          >
        </div>

        <div class="collection_contact">
          <div v-if="detail.is_collect" class="collect" @click="collect">
            <el-image
              :src="GetResourceUrl('home/icon-collection_1.svg')"
            ></el-image>
            {{ l("已收藏") }}
          </div>
          <div v-else class="collect" @click="collect">
            <el-image
              :src="GetResourceUrl('home/icon-collection_0.svg')"
            ></el-image>
            {{ l("加入收藏") }}
          </div>

          <div class="contact" @click="getContact">
            <el-image :src="GetResourceUrl('home/icon-tel.svg')"></el-image>
            {{ l("致电联系") }}
          </div>
        </div>
      </div>
      <div class="otherInfo">
        <div class="title">{{ l("其他信息") }}</div>
        <div class="infoLines">
          <div class="line">
            {{ l("计重方式") }}：
            {{
              $utils.listFilter(
                $store.state.basicInfo.weight_methodList,
                detail.weight_method
              )
            }}
          </div>

          <div class="line">
            {{ l("提供质保书") }}：{{ detail.have_warranty ? l("是") : l("否") }}
          </div>

          <div class="line">
            {{ l("发货地") }}：
            {{ detail.address }}
          </div>
        </div>
      </div>

      <div v-if="detail.description" class="descriptionContainer">
        <div class="title">{{ l("补充说明") }}</div>
        <div class="description" v-html="detail.description"></div>
      </div>
    </div>

    <div v-if="showEmpty" key="empty" class="emptyContainer">
      <el-empty>
        <div slot="description">{{ l("抱歉，该商品不存在或已下架。") }}</div>
      </el-empty>
    </div>
    <RecommendQuotationRightBar :size="2" />
    <BusinessDialog
      ref="businessDialog"
      :business_detail="detail"
      @submitDialog="businessCallback"
    />
  </div>
</template>

<script>
import RecommendQuotationRightBar from "@/components/layout/RecommendQuotationRightBar";
import BusinessDialog from "@/components/common/BusinessDialog";

export default {
  name: "HomeQuotationDetail",
  components: { RecommendQuotationRightBar, BusinessDialog },
  data() {
    return {
      detail: null,
      showEmpty: false,
      imgIndex: 0,
    };
  },
  created() {
    this.getQuotationDetail();
  },
  methods: {
    getQuotationDetail() {
      this.axios
        .get(`/api/visitor_quotation/${this.$route.params.code}/`)
        .then((data) => {
          console.log("data", data);
          data.img_array = JSON.parse(data.img_array);
          if (data.img_array.length > 5) {
            data.img_array.length = 5;
          }
          this.detail = data;
        })
        .catch(() => {
          this.showEmpty = true;
        });
    },
    collect() {
      if (this.detail.is_collect) {
        //axios delete的body需要包装在data内
        this.axios
          .delete(`/api/user_collection/cancel/`, {
            data: {
              code: this.detail.code,
            },
          })
          .then(() => {
            this.detail.is_collect = false;
          });
      } else {
        this.axios
          .post(`/api/user_collection/`, {
            code: this.detail.code,
            module: "quotation",
          })
          .then(() => {
            this.detail.is_collect = true;
          });
      }
    },
    doBusiness() {
      this.$refs.businessDialog.Show({
        module: "quotation",
      });
    },
    businessCallback(formData) {
      if (formData.code) {
        this.axios
          .put(`/api/business_action/${formData.code}/`, formData)
          .then(() => {});
      } else {
        this.axios.post(`/api/business_action/`, formData).then((res) => {
          this.detail.business_action_code = res.code; //更新business_action_code
        });
      }
    },
    getContact() {
      this.axios
        .get(`/api/account/get_contact/`, {
          params: {
            module: "quotation",
            code: this.detail.code,
          },
        })
        .then((res) => {
          this.$alert(res.mobile, res.display_name);
        });
    },
  },
};
</script>


<style scoped lang="scss">
.homeQuotationDetail {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  .detailContainer {
    // width: 950px;
    flex-grow: 1;
    margin-right: 10px;
    box-sizing: border-box;
    padding: 35px 30px 50px;
    background-color: #fff;
  }
  .mainContainer {
    display: flex;
    align-items: flex-start;
    position: relative;
    padding-bottom: 30px;
    border-bottom: 1px solid $borderPlainColor;
  }
}

.imgContainer {
  $mainImgWidth: 270px;
  width: $mainImgWidth;
  border: 1px solid $borderColor;

  .mainImg {
    width: $mainImgWidth;
    height: $mainImgWidth;
  }
  .imgList {
    display: flex;
    justify-content: flex-start;
    margin-top: 3%;

    .el-image {
      width: 50px;
      height: 50px;
      opacity: 0.6;
      box-sizing: border-box;
      cursor: pointer;
      & + .el-image {
        margin-left: 5px;
      }
      &.selected {
        opacity: 1;
        border: 2px solid $warningColor;
      }
    }
  }
}

.collection_contact {
  position: absolute;
  right: 10px;
  top: 0;

  .collect,
  .contact {
    display: flex;
    align-items: center;
    cursor: pointer;
    .el-image {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .collect {
    color: #666;
  }
  .contact {
    margin-top: 15px;
    color: $linkColor;
  }
}

.basicContainer {
  width: 520px;
  margin-left: 56px;
  box-sizing: border-box;
  .title {
    width: 450px;
    font-size: 20px;
    font-weight: bold;
  }
  .price {
    color: $warningColor;
    font-size: 24px;
    margin-top: 20px;
  }

  .materialInfo {
    margin-top: 40px;
    .line {
      display: flex;
      margin-bottom: 12px;
      line-height: 18px;
      // height: 18px;
    }
  }
}

.otherInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 45px;
    font-weight: bold;
  }
  .infoLines {
    margin: 30px 0;
    .line {
      display: flex;
      margin-top: 10px;
    }
  }
}
.descriptionContainer {
  border-top: 1px solid $borderPlainColor;
  box-sizing: border-box;
  .title {
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }
  .description {
    margin-top: 20px;
    width: 100%;
    white-space: pre-line;
  }
}

.emptyContainer {
  flex-grow: 1;
  margin-right: 10px;

  background: #fff;
  box-sizing: border-box;
  padding: 100px 0 120px;
}
</style>

